import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

import i11v1a from './i11v1a'; // 時間帯情報

export default class i10v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_i10rListsss: {i10r:[]},
  sdld_i10rDtlsss: {i10r:[]},
};

static op_loadSlcList = (pd={
  elm: null,
//  i11r_fst: null,
  i10rt11i: null,
}) => 
  (pd.elm == 'i10r') ?
    super.op_loadSlcList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
//        let _cnd = pd.cnd ?? cf.c('i10r');
        let _cnd = pd.cnd ?? `i10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst} AND _vsn = _ltt`;
        if (pd.i10rt11i) _cnd += ` AND i10rt11i = ${pd.i10rt11i}`;
        return _cnd;
      }),
      ld_sortss: [
        { fld: 'i10rc11s', dtn: 'asc', mode: 'nmb' }
      ],
    })
  : super.op_loadSlcList(pd);

$clp_loadLists = () => [ // 親を上書き
  i10v.op_loadList({
    elm: 'i10r',
    ld_sortss: [
      { fld: 'i10rc11s', dtn: 'asc', mode: 'nmb' }
    ],
  }),
  i11v1a.op_loadSlcList({ // 時間帯
    elm: 'i11r',
  }),
];

$clp_loadDtls = () => [
  i10v.op_loadDtl({
    elm: 'i10r',
  }),
  i10v.op_loadVsnList({ // 時間帯
    elm: 'i10r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_i10rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      i10r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            i10rb51f: _dd_datss.i10r.d_flds.i10rb51f ?? -1,
            i10rc11s: _dd_datss.i10r.d_flds.i10rc11s ?? '',
            i10rc31s: _dd_datss.i10r.d_flds.i10rc31s ?? '',
            i10rt11i: _dd_datss.i10r.d_flds.i10rt11i ?? -1,
            i10ri11i: _dd_datss.i10r.d_flds.i10ri11i ?? -1,
            i10ri21i: _dd_datss.i10r.d_flds.i10ri21i ?? -1,
            i10ri11m: _dd_datss.i10r.d_flds.i10ri11m ?? -1,
            i10rt21i: _dd_datss.i10r.d_flds.i10rt21i ?? -1,
          };
          return _d;
        },
      },
    },
  }),
];

$clp_dlts = () => 
  [
    new Promise( _o_end1 => {
      let _d_i10rs = global.t?.state.sdld_i10rDtlsss.i10r[0];
      cf.myRN_setDat('sdld_i10rDtlsss', _d_i10rs, _d_i10rs => {
        let _d = {
          i10rcz1i: 0,
        };
        return _d;
      })
      .then(() => {
        Promise.all(global.t?.$clp_upds())
        .then(_o_end1);
      });
    }),
  ]
;

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx: 
          (global.t?.state.sgc_pnlMode == 'list') ?
            '室・設備一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '室・設備詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '室・設備変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '室・設備新規登録'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【室・設備詳細の確認・変更】･･･IDを押すと詳細画面に移動し、変更もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i10rListsss',
                    dd_elmDefss: {
                      i10r: {
                        elm: 'i10r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_insFlds: cf.e('i10r').d_insFlds,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i10rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('i10rc31s', {
                            d_hdrs: { n_w: ic.s(16)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i10rt11i', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                        ]),

                      },
                    },
                  }),
                ])

              ],
            },
            d_btms: {
/*
              d_news: {
                elm: 'i10r',
                state: 'sdld_i10rDtlsss',
                d_insFlds: {
                  ...cf.e('i10r').d_insFlds, 
                },
              },
*/
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '室・設備の新規登録',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(12),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'i10r',
                        state: 'sdld_i10rDtlsss',
                        d_insFlds: {
                          ...cf.e('i10r').d_insFlds, 
                        },
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'i10r',
                ld_iss: global.t?.state.sdld_i10rVsnListsss?.i10r,
                op_loadDtl: i10v.op_loadDtl,
              },
            },
            d_bdys: {
              l_clds: [
                ce.c(cr.InpTree, {
                  key: -1,
                  state: 'sdld_i10rDtlsss',
                  dd_elmDefss: {
                    i10r: {
                      elm: 'i10r',
                      b_ttl: true,
                      d_insFlds: cf.e('i10r').d_insFlds,
                      d_btns: {
                        d_dlts: {
                          b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                        },
                      },
                      d_cmns: {
                        n_cnt: 1,
                      },
                      dd_fldDefss: cf.myRN_getFldDefs([
                        cf.f('i10rc11s', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10rc31s', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10rt11i', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                          ld_iss: [
                            { key: 200, pfx: '室', }, // 室
                            { key: 400, pfx: '設備', }, // 室と同時に予約
                          ]
                        }),
                        cf.f('i10rb51f', {
                          ld_iss: global.t?.state.sdld_i11rSlcListsss?.i11r,
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10ri11i', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10ri21i', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10ri11m', {
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                        cf.f('i10rt21i', {
                          ob_vsb: _d_dats => {
//ff.l('244: {}'.f(_d_dats))
                            if (_d_dats.d_flds.i10rt11i == 400) {
                              return true;
                            }
                            else {
                              return false;
                            };
                          }, 
                          d_hdrs: { n_w: ic.s(6)  },
                          d_bdys: { n_w: ic.s(16) },
                        }),
                      ]),

                    },
                  },
                }),
              ],
            },
            d_btms: {
              b_dlt: true,
            },
          }),

        ],
      }
    })
  );
}

}
